import PropTypes from 'prop-types';

import LanguageModel from './Language';
import OgTagsModel from './OgTags';
import PageLinkModel from './PageLink';
import AwardCounterModel from './AwardCounter';
import EmployeeModel from './Employee';
import JobModel from './Job';

export default {
  id: PropTypes.number.isRequired,
  language: PropTypes.shape(LanguageModel).isRequired,
  ogTags: PropTypes.shape(OgTagsModel).isRequired,
  navLinks: PropTypes.arrayOf(PropTypes.shape(PageLinkModel)).isRequired,
  companySectionHeading: PropTypes.string.isRequired,
  companySectionTitle: PropTypes.string.isRequired,
  companySectionParagraph1: PropTypes.string.isRequired,
  companySectionParagraph2: PropTypes.string.isRequired,
  recognitionSectionHeading: PropTypes.string.isRequired,
  recognitionSectionTitle: PropTypes.string.isRequired,
  recognitionSectionParagraph1: PropTypes.string.isRequired,
  recognitionSectionParagraph2: PropTypes.string.isRequired,
  teamSectionHeading: PropTypes.string.isRequired,
  teamSectionTitle: PropTypes.string.isRequired,
  teamSectionParagraph1: PropTypes.string.isRequired,
  featuredEmployees: PropTypes.arrayOf(PropTypes.shape(EmployeeModel)).isRequired,
  employees: PropTypes.arrayOf(PropTypes.shape(EmployeeModel)).isRequired,
  careerSectionHeading: PropTypes.string,
  careerSectionTitle: PropTypes.string.isRequired,
  careerSectionParagraph1: PropTypes.string.isRequired,
  careerSectionParagraph2: PropTypes.string.isRequired,
  careerSectionEmail: PropTypes.string.isRequired,
  careerSectionOpenPositionsHeading: PropTypes.string.isRequired,
  openPositions: PropTypes.arrayOf(PropTypes.shape(JobModel)).isRequired,
  contactSectionHeading: PropTypes.string,
  contactSectionTitle: PropTypes.string.isRequired,
  contactSectionParagraph1: PropTypes.string.isRequired,
  contactSectionParagraph2: PropTypes.string.isRequired,
  contactSectionEmail: PropTypes.string.isRequired,
  footerLinkPrev: PropTypes.shape(PageLinkModel).isRequired,
  footerLinkNext: PropTypes.shape(PageLinkModel).isRequired,
};
